import axios from "axios";

export const TOKEN = "AUTH_TOKEN";

export const SetAuthToken = (token?: string | null) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = token;
    axios.defaults.headers.common["frontend-source"] = "webadmin";
  } else {
    delete axios.defaults.headers.common["Authorization"];
    delete axios.defaults.headers.common["frontend-source"];
  }
};

export const useURL = process.env.REACT_APP_BACKEND_URL;

console.log(useURL);

export const SetDefaultHeaders = () => {
  axios.defaults.baseURL = useURL;
  axios.defaults.headers.common["frontend-source"] = "webadmin";
};
